/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { AlertFilter, AlarmSeverity, AlertStatus, AlertActionFilter } from "model";
import { AlertTab } from "model/state";

function getSeverity(currentTab: AlertTab): AlarmSeverity | undefined {
  switch(currentTab) {
    case 'all':
      return undefined;
    case 'critical':
      return AlarmSeverity.CRITICAL;
    case 'warning':
      return AlarmSeverity.WARNING;
    case 'logs':
      return undefined;
    default:
      return undefined;
  }
}

function getStatus(currentTab: AlertTab): AlertStatus | undefined {
  switch(currentTab) {
    case 'all':
      return undefined;
    case 'critical':
      return AlertStatus.TRIGGERED;
    case 'warning':
      return AlertStatus.TRIGGERED;
    case 'logs':
      return AlertStatus.RESOLVED;
    default:
      return undefined;
  }
}

export function generateAlertFilter(currentTab: AlertTab, currentPage: number, searchVal: string, locationIds: Array<string>, alarmNames: Array<string>, activeOnly: boolean): AlertFilter {
  return {
    severity: getSeverity(currentTab),
    status: getStatus(currentTab),
    page: currentPage,
    search: searchVal,
    locationIds,
    alarmNames,
    activeOnly,
  };
};

export function useNotificationService(
  fetchAlertsByUserId:  (userId: string, filter: AlertFilter) => void,
  userId:               string | null | undefined,
  currentTab:           AlertTab,
  currentPage:          number,
  search:               string,
  isSubmitting:         boolean,
  hasError:             boolean,
  filters:              AlertActionFilter,
): void {
  const searchVal = search.trim().length > 2 ? search.trim() : '';

  const filter: AlertFilter = generateAlertFilter(currentTab, currentPage, searchVal, filters.locationIds, filters.alarmNames, filters.activeOnly);

  useEffect(() => {
    if (userId && !isSubmitting && !hasError) {
      fetchAlertsByUserId(userId, filter);
    }
  }, [userId, currentTab, currentPage, searchVal, isSubmitting, filters.locationIds, filters.alarmNames, filter.activeOnly]);
}
